module.exports = __webpack_public_path__ + "static/media/pokeStore.0c77ce8f.png";